import React, { useState, useRef, useEffect } from 'react'
import DataTable from '../../../Components/DataTable/DataTable';
import { Button, Modal, FormGroup, Form, Label, Input, ModalBody, Row, Col } from 'reactstrap';
import "../../pages.css"
import Header from '../../../Layout/Admin/Header';
import { Calendar } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { el, enGB } from "date-fns/locale";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import { BsCaretDownFill } from 'react-icons/bs';
import withAuth from "../../../Components/CheckSessionStorage/sessionUtils";
import EmailReportModal from '../../../Components/Modals/EmailReportModal';
import apiRequest from '../../../api';

const AdminUsers = () => {
  const selectedLanguageRef = useRef(localStorage.getItem('Language'));

  const columns_en = [{ title: 'Username', key: "username" }, { title: 'Role', key: "role" }, { title: 'Email', key: "email" }];
  const columns_rs = [{ title: 'Korisnik', key: "username" }, { title: 'Uloga', key: "role" }, { title: 'Email', key: "email" }];

  // Add state for selected users set
  const [selectedUsers, setSelectedUsers] = useState(new Set());

  const [columns, setColumns] = useState(() => {
    return (selectedLanguageRef.current === "EN" ? columns_en : columns_rs);
  });

  useEffect(() => {
    // Handle changes from other tabs/windows and local changes
    const handleLanguageChange = (event) => {
      selectedLanguageRef.current = event.detail['selectedLanguage'];
      setColumns(selectedLanguageRef.current === "EN" ? columns_en : columns_rs)
    };

    window.addEventListener('languageChange', handleLanguageChange);
    return () => {
      window.removeEventListener('languageChange', handleLanguageChange);
    };
  }, []);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true); // To manage loading state
  const [error, setError] = useState(null); // To manage error state


  const [modalOpen, setModalOpen] = useState(false);
  const [sendmodalOpen, setSendModalOpen] = useState(false);
  const [editModal, setEditModal] = useState(false)
  const [selectedRole, setSelectedRole] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const roles = ["USER", "MANAGER"];
  const [formDetails, setFormDetails] = useState({
    username: "",
    password: "",
    email: "",
  });
  const [errors, setErrors] = useState({
    username: "",
    password: "",
    email: "",
    role: "",
  });
  const dropdownRef = useRef(null); // Reference for the dropdown container

  const [filterText, setFilterText] = useState(""); // State to store the input value
  const [filteredData, setFilteredData] = useState([]); // State to store filtered results


  const [buttonText, setButtonText] = useState(
    selectedLanguageRef.current === "EN" ? "Send Analytics" : "Pošalji Analitiku"
  );

  useEffect(() => {
    const updateButtonText = () => {
      if (window.innerWidth < 768) {
        setButtonText(selectedLanguageRef.current === "EN" ? "Send" : "Pošalji");
      } else {
        setButtonText(
          selectedLanguageRef.current === "EN" ? "Send Analytics" : "Pošalji Analitiku"
        );
      }
    };

    // Add event listener for window resize
    window.addEventListener("resize", updateButtonText);

    // Call the function initially to set the correct text
    updateButtonText();

    // Cleanup event listener on component unmount
    return () => window.removeEventListener("resize", updateButtonText);
  }, [selectedLanguageRef]);


  // Function to handle user selection
  const handleUserSelection = (user) => {
    setSelectedUsers(prevSelectedUsers => {
      const newSelectedUsers = new Set(prevSelectedUsers);

      if (newSelectedUsers.has(user.id)) {
        newSelectedUsers.delete(user.id);
      } else {
        newSelectedUsers.add(user.id);
      }

      return newSelectedUsers;
    });
  };

  // Function to clear selected users
  const clearSelectedUsers = () => {
    setSelectedUsers(new Set());
  };
  const toggleSendModal = () => {
    if(sendmodalOpen === true){
      clearSelectedUsers();
    }
    setSendModalOpen(!sendmodalOpen);
  };
  // Function to handle input change
  const handleFilterChange = (e) => {
    const value = e.target.value; // Convert input to lowercase for case-insensitive filtering
    setFilterText(value);
    // Filter data based on the input value
    filterData(value.toLowerCase(), data);
  };

  const filterData = (value, data) => {
    const filtered = data.filter((item) =>
      item.username.toLowerCase().startsWith(value) // Filter by 'username' starting with the input
    );
    setFilteredData(filtered);
  };



  const toggleDropdown = () => {
    setDropdownOpen((prevState) => !prevState); // Toggle dropdown visibility
  };

  const handleRoleSelect = (role) => {
    setSelectedRole(role); // Set the selected role
    setDropdownOpen(false); // Close the dropdown
  };

  const toggleModal = (e) => {
    e.preventDefault()
    setFormDetails({
      username: "",
      password: "",
      email: "",
    });
    setErrors({
      username: "",
      password: "",
      email: "",
      role: ""
    });
    setSelectedRole("");
    setModalOpen(!modalOpen)
  };
  const toggleEditModal = (row) => {
    if (editModal === true) {
      // Close modal, no need for additional action when closing
      setEditModal(false);
    } else {

      const selectedRow = row;
      console.log("Row from dataTable:", row);
      setFormDetails({
        username: selectedRow.username,
        password: selectedRow.password,
        email: selectedRow.email,
      });
      setErrors({
        password: "",
        email: "",
      })
      setEditModal(true);
    }
  };

  const handleEditModalSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {
      password: formDetails.password === "" ? "This field is required" : "",
      email: formDetails.email === "" ? "This field is required" : "",
    };
    setErrors({
      ...newErrors
    });

    if (newErrors.password || newErrors.email) {
      return;
    }
    // Create the request body
    const requestBody = {
      username: formDetails.username,
      password: formDetails.password,
      email: formDetails.email,
    };

    // Make the POST request
    try {
      const token = sessionStorage.getItem("jwt"); // Retrieve JWT token from localStorage
      const response = await apiRequest('/api/users/editUser', 'POST', requestBody, token);

      // Handle the response
      console.log("User edited successfully:", response);
      fetchUsers();
      setEditModal(false); // Close the modal after successful submission

    } catch (error) {
      alert(error.message);
    }
  };
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick); // Use mousedown for immediate response
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const handleInputChange = (e, field) => {
    const { name, value } = e.target;

    formDetails[name] = value;

    setFormDetails({ ...formDetails });
  };

  const handleModalSubmit = async (e) => {
    e.preventDefault()
    const newErrors = {
      password: formDetails.password === "" ? "This field is required" : "",
      email: formDetails.email === "" ? "This field is required" : "",
      username: formDetails.username === "" ? "This field is required" : "",
      role: selectedRole ? "" : "This field is required",
    };
    setErrors({
      ...newErrors
    });

    if (newErrors.password || newErrors.email || newErrors.username || newErrors.role) {
      return;
    }
    const requestBody = {
      username: formDetails.username,
      password: formDetails.password,
      email: formDetails.email,
      role: selectedRole,
      language: selectedLanguageRef.current,
    };

    // Make the POST request
    try {
      const token = sessionStorage.getItem("jwt"); // Retrieve JWT token from localStorage
      const response = await apiRequest('/api/users/createUser', 'POST', requestBody, token);

      // Handle the response
      console.log("User created successfully:", response);
      fetchUsers();
      setModalOpen(false); // Close the modal after successful submission

    } catch (error) {
      try {
        // Parse the error message
        const errorData = JSON.parse(error.message);
        if (errorData.Body && errorData.Body.error) {
          window.alert(errorData.Body.error); // Display the error message
        }
      } catch (parseError) {
        console.error("Failed to parse error message:", parseError);
      }
    }
  };

  const fetchUsers = async () => {
    console.log("Usao u fetch");
    try {
      // Retrieve JWT from localStorage
      const token = sessionStorage.getItem("jwt");

      const users = await apiRequest(`/api/users/get_all_users`, 'GET', null, token);
      console.log("Users:", users);
      const formattedData = users.map((user) => {

        return {
          username: user.username,
          password: user.password,
          email: user.email,
          role: user.role.charAt(0).toUpperCase() + user.role.slice(1).toLowerCase(),
          id: user.username,
        };
      });
      const sortedData = [...formattedData].sort((a, b) =>
        a.username.toLowerCase().localeCompare(b.username.toLowerCase())
      );
      setData(sortedData);
      filterData(filterText, sortedData);
      console.log("Data:", sortedData);
    } catch (err) {
      setError(err.message);
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true); // Start loading
      await fetchUsers(); // Fetch data
      setLoading(false); // Stop loading
    };

    fetchData();
  }, []); // Runs only once when the component is mounted



  if (loading) {
    return <Header />;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <React.Fragment>
      <Header />

      <div className='container  ' >
        <div className='table-container-1' >
          <div className="row my-3 ">
            <Col xs={8} md="6" className=" text-end d-flex justify-content-start ">
              <div className="  form-group position-relative filter_input d-flex align-items-center ">
                <img
                  src="/assets/icons/search.svg"
                  alt="Calendar Icon"
                  className="calendar-icon"
                />
                <input
                  name="filter"
                  type="text"
                  className="form-control custom-input "
                  placeholder={selectedLanguageRef.current === 'EN' ? "Filter Users..." : "Pretraga Korisnika..."}
                  style={{ width: "100%" }}
                  value={filterText} // Bind input value to state
                  onChange={handleFilterChange} // Call the filter function on input change
                />
              </div>
            </Col>
            <Col
              xs={4}
              md="6"
              className="text-end d-flex align-items-start justify-content-end"
            >
              <div className='text-center text-md-end btn-container d-flex justify-content-end justify-content-md-end'>
                {selectedUsers.size > 0 ? (
                  <div className="button-group transition-group">
                    <Button className='cancel-btn btn-secondary exit'>
                      {`${selectedUsers.size}/${data.length}`}
                    </Button>
                    <Button onClick={clearSelectedUsers} className='cancel-btn btn-secondary'>
                      {selectedLanguageRef.current === 'EN' ? 'Cancel' : 'Otkaži'}
                    </Button>
                    <Button onClick={toggleSendModal} className='analytics-btn'>
                      {buttonText}
                    </Button>
                  </div>
                ) : (
                    <Button onClick={toggleModal} className='add-btn transition-group'>+</Button>
                )}
              </div>
            </Col>
          </div>
          <div className='row' style={{ justifyContent: "center", position: "relative" }} >
            <DataTable
              onEdit={(row) => toggleEditModal(row)}
              data={filteredData}
              fetchReservations={() => fetchUsers()}
              columns={columns}
              selectedUsers={selectedUsers}
              onUserSelect={handleUserSelection}
            />
          </div>
        </div>
      </div>

      <Modal isOpen={editModal} toggle={toggleEditModal} centered className="custom-model" >
        <ModalBody className="pt-2">
          <Form>
            <div className="row justify-content-center mt-5">
              <div className="col-md-8">
                <FormGroup>
                  <Label className=" label w-100 "> {selectedLanguageRef.current === 'EN' ? "User" : "Korisnik"} </Label>
                  <Label className=" label w-100 text-center"> {formDetails.username} </Label>
                </FormGroup>
              </div>
            </div>

            <div className="row justify-content-center">
              <div className="col-md-8">
                <FormGroup>
                  <Label className='label' >{selectedLanguageRef.current === 'EN' ? "Password" : "Šifra"}</Label>
                  <Input
                    type="text"
                    name="password"
                    value={formDetails.password}
                    onChange={handleInputChange}
                    className={errors.password ? "input-error" : ""}
                  />
                </FormGroup>
              </div>
            </div>

            <div className="row justify-content-center mb-5">
              <div className="col-md-8">
                <FormGroup>
                  <Label className='label' >Email</Label>
                  <Input
                    type="text"
                    name="email"
                    value={formDetails.email}
                    onChange={handleInputChange}
                    className={errors.email ? "input-error" : ""}
                  />
                </FormGroup>
              </div>
            </div>

            <FormGroup>
              <div className="row">
                <div className="col-md-6 col-6 d-flex justify-content-center align-items-center">
                  <button
                    className=" model-btn-cancel btn btn-secondary rounded-2 py-1 px-5"
                    onClick={toggleEditModal}
                    type="button"
                  >
                    {selectedLanguageRef.current === 'EN' ? "Cancel" : "Otkaži"}
                  </button>
                </div>
                <div className="col-md-6 col-6 d-flex justify-content-center align-items-center">
                  <button
                    className=" model-btn btn btn-primary rounded-2 py-1 px-5"
                    onClick={handleEditModalSubmit}
                    type="button"
                  >
                    {selectedLanguageRef.current === 'EN' ? "Apply" : "Primeni"}
                  </button>
                </div>
              </div>
            </FormGroup>
          </Form>
        </ModalBody>
      </Modal>
      <Modal
        isOpen={modalOpen}
        toggle={toggleModal}
        centered

        className="custom-model"
      >
        <ModalBody className="pt-2">
          <Form>
            <div className="row justify-content-center mt-2">
              <div className="col-md-8">
                <FormGroup>
                  <Label className='label' >
                    {selectedLanguageRef.current === 'EN' ? "Username" : "Korisničko ime"}
                  </Label>
                  <Input
                    type="text"
                    name="username"
                    value={formDetails.username}
                    onChange={handleInputChange}
                    className={errors.username ? "input-error" : ""}
                  />
                </FormGroup>
              </div>
            </div>

            <div className="row justify-content-center">
              <div className="col-md-8">
                <FormGroup>
                  <Label className='label' >
                    {selectedLanguageRef.current === 'EN' ? "Role" : "Rola"}
                  </Label>

                  <div className={"custom-dropdown"} ref={dropdownRef}>
                    <div
                      className={`dropdown-selected ${errors.role ? "input-error" : ""}`}
                      onClick={toggleDropdown}
                    >
                      {selectedRole || `${selectedLanguageRef.current === 'EN' ? "Select Role" : "Izaberi Rolu"}`}
                      <span className="dropdown-arrow"><BsCaretDownFill fontSize={16} color='#888' /></span>
                    </div>
                    <div
                      className={`dropdown-options ${dropdownOpen ? "open" : ""
                        }`}
                    >
                      {roles.map((role, index) => (
                        <div
                          key={index}
                          className={`dropdown-option ${selectedRole === role ? "selected" : ""
                            }`}
                          onClick={() => handleRoleSelect(role)}
                        >
                          {role}
                        </div>
                      ))}
                    </div>
                  </div>
                </FormGroup>
              </div>
            </div>

            <div className="row justify-content-center">
              <div className="col-md-8">
                <FormGroup>
                  <Label className='label' >
                    {selectedLanguageRef.current === 'EN' ? "Password" : "Šifra"}
                  </Label>
                  <Input
                    type="text"
                    name="password"
                    value={formDetails.password}
                    onChange={handleInputChange}
                    className={errors.password ? "input-error" : ""}
                  />
                </FormGroup>
              </div>
            </div>

            <div className="row justify-content-center mb-5">
              <div className="col-md-8">
                <FormGroup>
                  <Label className='label' >
                    Email
                  </Label>
                  <Input
                    type="text"
                    name="email"
                    value={formDetails.email}
                    onChange={handleInputChange}
                    className={errors.email ? "input-error" : ""}
                  />
                </FormGroup>
              </div>
            </div>

            <FormGroup>
              <div className="row">
                <div className="col-md-6 col-6 d-flex justify-content-center align-items-center">
                  <button
                    className=" model-btn-cancel btn btn-secondary rounded-2 py-1 px-5"
                    onClick={toggleModal}
                    type="button"
                  >
                    {selectedLanguageRef.current === 'EN' ? "Cancel" : "Otkaži"}
                  </button>
                </div>
                <div className="col-md-6 col-6 d-flex justify-content-center align-items-center">
                  <button
                    className=" model-btn btn btn-primary rounded-2 py-1 px-5"
                    onClick={handleModalSubmit}
                    type="button"
                  >
                    {selectedLanguageRef.current === 'EN' ? "Create" : "Napravi"}
                  </button>
                </div>
              </div>
            </FormGroup>
          </Form>
        </ModalBody>
      </Modal>
      
      <EmailReportModal
        isOpen={sendmodalOpen}
        toggle={toggleSendModal}
        selectedUsers={Array.from(selectedUsers)} 
      />
    </React.Fragment>
  )
}

export default withAuth(AdminUsers);